/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable */

export default class DevZoneForms {
  constructor() {
    this.selector = '.b-dev-zone-forms';
  }

  bootstrap() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];

    if (blocks.length === 0) {
      return;
    }

    if ($('form[action*="salesforce"]').length) {
      const relationships = {

        'DFC - Dataflow compiler': {
          'Sub SW Product Type': [ 'Documents', 'Installation/Other/Examples', 'Parser', 'Optimization', 'Compilation', 'Other' ],
          'SW Product Version': [ '3.23.0', '3.24.0', '3.25.0', '3.26.0', 'Other' ],
          'Root Product': [ '', 'Hailo-8', 'Hailo-8R', 'Hailo-8L', 'Hailo-15H', 'Hailo-15M'],
          Architecture: [],
          'HailoRT Framework': [],
          'Model Zoo - NN Model': [],
        },

        HailoRT: {
          'Sub SW Product Type': [ 'YOCTO', 'Driver', 'Documents', 'Installation/Other/Examples', 'Python', 'Windows', 'Integration Tool', 'Other' ],
          'SW Product Version': [ '4.12.0', '4.12.1', '4.13.0', '4.14.0', '4.15.0', '4.16.0', 'Other' ],
          'Root Product': [ '', 'Hailo-8', 'Hailo-8R', 'Hailo-8L', 'Hailo-15H', 'Hailo-15M'],
          Architecture: [ 'X86', 'Aarch64', 'Aarch32', 'rpi4', 'rockchip', 'Other' ],
          'HailoRT Framework': [ 'C', 'C++', 'Python', 'Gstreamer' ],
          'Model Zoo - NN Model': [],
        },

        Tappas: {
          'Sub SW Product Type': [ 'Installation/Other/Examples', 'Pre & Post Processing/Image Acquire/Visualizations', 'GStreamer Plugins', 'Other' ],
          'SW Product Version': [ '3.24.0', '3.25.0', '3.26.0', 'Other' ],
          'Root Product': [ '', 'Hailo-8', 'Hailo-8R', 'Hailo-8L', 'Hailo-15H', 'Hailo-15M'],
          Architecture: [ 'X86', 'Aarch64', 'Aarch32', 'rpi4', 'rockchip', 'Other' ],
          'HailoRT Framework': [],
          'Model Zoo - NN Model': [],
        },

        'Model Zoo': {
          'Sub SW Product Type': [ 'Documents', 'Parser/Eval/Quantization/Allocation/Compilation', 'Retrain', 'Other' ],
          'SW Product Version': [ '2.6.0', '2.7.0', '2.8.0', '2.9.0', '2.10.0', 'Other' ],
          'Root Product': [ '', 'Hailo-8', 'Hailo-8R', 'Hailo-8L', 'Hailo-15H', 'Hailo-15M'],
          Architecture: [],
          'HailoRT Framework': [],
          'Model Zoo - NN Model': [ 'Classification', 'Object Detection', 'Semantic Segmentation', 'Pose Estimation', 'Face Detection', 'Instance Segmentation', 'Depth Estimation' ],
        },

        'Hailo-15': {
          'Sub SW Product Type': [ 'Application & Pipeline', 'BSP', 'DSP', 'Imaging', 'Build System & Distribution', 'Hailo-15 Hardware Review', 'Other' ],
          'SW Product Version': [ 'Other' ],
          'Root Product': [ '', 'Hailo-15H', 'Hailo-15M'],
          Architecture: [],
          'HailoRT Framework': [],
          'Model Zoo - NN Model': [],
        },

        Other: {
          'Sub SW Product Type': [ 'Other' ],
          'SW Product Version': [ '4.12.0', '4.12.1', '4.13.0', '4.14.0', '4.15.0', '1.13.0', '1.14.0', '1.15.0', '3.23.0', '3.24.0', '3.25.0', '3.26.0', '2.6.0', '2.7.0', '2.8.0', '2.9.0', 'Other' ],
          'Root Product': [ '', 'Hailo-8', 'Hailo-8R', 'Hailo-8L', 'Hailo-15H', 'Hailo-15M'],
          Architecture: [],
          'HailoRT Framework': [],
          'Model Zoo - NN Model': [],
        },
      };

      const form = $('form[action*="salesforce"]');

      if ($('.relational-wrap').length) {
        form.on('change', 'select[title="SW Product Type"]', function () {
          const typeVal = $(this).val();

          form.find('.relation-select select').val('');

          let countFields = 0;

          const relations = relationships[typeVal];

          if (!relations) {
            form.find('.relation-select').parent().hide();
          }

          for (const key in relations) {
            if (!relations.hasOwnProperty(key)) {
              continue;
            }

            const relationData = relations[key];

            const selectField = form.find(`select[title="${key}"]`);

            if (!relationData.length) {
              selectField.parent().parent().hide();
            } else {
              selectField.parent().parent().show();
              selectField.find('option').each(function () {
                const optValue = $(this).val();

                if (relationData.includes(optValue)) {
                  $(this).show();
                  countFields++;
                } else {
                  $(this).hide();
                }
              });
            }
          }

          if (countFields > 0) {
            $('.relational-wrap').show();
          } else {
            $('.relational-wrap').hide();
          }
        });

        form.on('change', 'select[title="Sub SW Product Type"]', function () {
          const subValue = $(this).val();

          if (subValue === 'Integration Tool') {
            form.find('select[title="Integration Tool Version"]').parent().parent().show();
          } else {
            form.find('select[title="Integration Tool Version"]').parent().parent().hide();
          }
        });
      }

      form.find('select[name="priority"] option[value="Low"]').attr('selected', true).prop('selected', true);

      $.ajax({
        method: 'post',
        url: window.af_app.ajaxurl,
        dataType: 'json',
        data: {
          action: 'get_user_form_data',
        },
        success(response) {
          if (response.success) {
            form.find('input[name="name"]').attr('readonly', true).val(response.data.name);

            const email = form.find('input[name="email"]');
            email.attr('readonly', true).val(response.data.email);
            email.get(0).dispatchEvent(new Event('change'));

            form.find('input[name="company"]').attr('readonly', true).val(response.data.company);
            if (form.find(`select[title="Country"] option[value="${response.data.country}"]`).length) {
              console.log('found country');
              form.find(`select[title="Country"] option[value="${response.data.country}"]`).attr('selected', true).prop('selected', true);
            } else {
              console.log('not found country');
              form.find('select[title="Country"] option[value="Israel"]').attr('selected', true).prop('selected', true);
            }
            form.find('select[title="Country"]').hide();
          }
        },
      });
    }
  }
}
